import React, {Component} from 'react'
import { Link } from 'gatsby'
import './Card.css'
import ModalShards from '../components/ModalShards.js'


const imageClick = (project) => {
  console.log(project);
  alert(project);
}

const UpdateCard = ({isHidden}) => {
  console.log("Update!!");
}

const Card = props => (
  <div className="Card" id={props.id}>
    <div onClick={props.onClick}></div>
    <img src={props.image} id={props.text} onClick={props.action} /*onClick={() => imageClick(props.text)}*/ />
    <p>{props.title}</p>
    <h4>{props.text}</h4>
    <div className="cardInnerShadow"></div> 

    {(() => {
        if (props.id ==="false"){

          console.log("update!!");
          //setTimeout(function(){ alert("Hello"); }, 900);
        }
      })()}
  </div>

)


export default Card


/*
export default class Card extends Component{
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(){
    //this.props.click(this.props.text)
    console.log(this.props.text);

  }

  render(){
    return(
      <div className="Card">
        <div onClick={this.props.action}></div>
        <img src={this.props.image} onClick={this.props.action} onClick={this.handleClick} />
        <p>{this.props.title}</p>
        <h4>{this.props.text}</h4>
      </div>
    );
  }
}
*/
